module.exports = __webpack_public_path__ + "static/media/bridge_blue.cfb8a6dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bridge_blue.jpg
// module id = 191
// module chunks = 0